import React, { useState } from 'react';
import './FAQPage.css'; // Include the CSS file for styling
const faqs = [
  {
    question: "How do I arrange shipping for my vehicle?",
    answer: `Once you’ve won an auction and completed your purchase, you can request shipping by filling out the Shipping Request Form or contacting our customer service team. We’ll provide you with a shipping quote and timeline for delivery.`,
  },
  {
    question: "What shipping options are available?",
    answer: `We offer several shipping options to meet your needs:
    - **Roll On, Roll Off (RORO):** The vehicle is delivered directly to your address.
    - **LCL Container:** You can pick up your vehicle at a designated shipping terminal.
    - **FCL Container:** Faster delivery options available for an additional fee.
    
    **RORO Fees:**
    - Ground Trucking: Varies based on the vehicle's distance from the port.
    - Ocean Freight: Starts at $1350 for sedans or small SUVs and increases for larger vehicles.
    - TELEX/OBL: Documentation costs range from $25-$75.`,
  },
  {
    question: "How much does shipping cost?",
    answer: `Shipping costs vary based on:
    - Vehicle Size and Weight
    - Delivery Location
    - Type of Shipping
    - Distance from Auction Location
    Submit a shipping request for an accurate quote.`,
  },
  {
    question: "How long will it take for my vehicle to arrive?",
    answer: `Shipping times vary:
    - **RORO:** 6-9 weeks on average.
    - **Container:** 4-8 weeks longer, up to 3-4 months.`,
  },
  {
    question: "Can I track the status of my shipment?",
    answer: `Yes, you will receive tracking details upon port in-gate and email notifications for key milestones.`,
  },
  {
    question: "Can I arrange for my own shipping?",
    answer: `Yes, you can arrange your own shipping. We will provide the release information. Note that pending fees may result in a Customs hold.`,
  },
  {
    question: "Do you ship internationally?",
    answer: `Yes, international shipping is available. Contact customer service for quotes and details.`,
  },
  {
    question: "What should I do when my vehicle arrives?",
    answer: `- Clear customs to avoid demurrages.
    - Inspect the vehicle for damages and notify us immediately if any issues are found.`,
  },
  {
    question: "Can I change my shipping destination after placing the request?",
    answer: `Contact us as soon as possible. Changes might not be possible after the vehicle is loaded, and additional charges may apply.`,
  },
  {
    question: "What happens if I miss the delivery?",
    answer: `The carrier may reschedule delivery or charge a redelivery fee if multiple attempts are needed.`,
  },
  {
    question: "Can I pick up my vehicle instead of having it shipped?",
    answer: `Yes, you can pick up your vehicle from the auction location or a designated terminal. Notify us in advance.`,
  },
  {
    question: "Are there any additional fees for shipping?",
    answer: `Possible fees include:
    - Fuel Surcharge
    - Redelivery Fee
    - Liftgate Fee
    These will be communicated before confirming your request.`,
  },
  {
    question: "Can I ship my vehicle to a business address?",
    answer: `Yes, vehicles can be shipped to accessible business addresses, which may reduce costs.`,
  },
  {
    question: "What if my vehicle gets damaged during shipping?",
    answer: `- Document the damage upon delivery.
    - Notify us within 24 hours.
    - We will assist in filing a claim with the carrier.`,
  },
  {
    question: "How do I get a shipping quote?",
    answer: `Fill out the Shipping Request Form in your account to receive an accurate quote.`,
  },
];

const FAQPage = () => {
    const [activeIndex, setActiveIndex] = useState(null);
  
    const toggleFAQ = (index) => {
      setActiveIndex(index === activeIndex ? null : index);
    };
  
    return (
      <div class="faq-container1">
        <h1 class="faq-title1">Frequently Asked Questions (FAQs)</h1>
        <p class="faq-description1">
          We understand that arranging for vehicle shipping can be an important part of your purchasing process. If you need more assistance, don’t hesitate to contact our customer service team.
        </p>
        <ul class="faq-list1">
          {faqs.map((faq, index) => (
            <li key={index} class="faq-item1">
              <button onClick={() => toggleFAQ(index)} class="faq-question1">
                {faq.question}
              </button>
              {activeIndex === index && <p class="faq-answer1">{faq.answer}</p>}
            </li>
          ))}
        </ul>
        <div class="contact-section1">
          <h2>Need Further Assistance?</h2>
          <p>
            Phone: <a href="tel:1-800-123-4567">1-800-123-4567</a>
            <br />
            Email: <a href="mailto:shipping@autoauctionmall.com">shipping@autoauctionmall.com</a>
            <br />
            Live Chat: Available Monday to Friday, 9 AM - 6 PM
          </p>
        </div>
      </div>
    );
  };
  
  export default FAQPage;
